import { render, staticRenderFns } from "./PageBlocksMiniTable.vue?vue&type=template&id=4c4e37f4"
import script from "./PageBlocksMiniTable.vue?vue&type=script&lang=js"
export * from "./PageBlocksMiniTable.vue?vue&type=script&lang=js"
import style0 from "./PageBlocksMiniTable.vue?vue&type=style&index=0&id=4c4e37f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports